import { render, staticRenderFns } from "./ReviewWords.vue?vue&type=template&id=6aa461a5&scoped=true&"
import script from "./ReviewWords.vue?vue&type=script&lang=js&"
export * from "./ReviewWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa461a5",
  null
  
)

export default component.exports